<div class="qrcode">
  <a (click)="onClose()" class="close tablet">
    {{ 'actions.close' | translate }}
  </a>
  <ion-spinner *ngIf="loading"></ion-spinner>
  <img *ngIf="!loading" [src]="data" width="400" height="400" alt="" />
</div>
